import { Calendar } from '../types/interfaces';

export const CalendarTemplate: Calendar = {
  id: 0,
  name: '',
  description: '',
  weeklySpecialDays: [],
  specialDays: []
};
